import styled from 'styled-components';

import {breakpoint, colors} from '@app/styles/theme';

import {Hint} from '@shared/ui/Hint';
import {Icon} from '@shared/ui/Icon';
import {Title} from '@shared/ui/Title';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    color: ${colors.black};
    min-height: calc(100vh - 120px);
`;

export const Form = styled.form`
    max-width: 530px;
    width: 100%;
`;

export const PasswordContent = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    padding: 20px 20px;
    box-sizing: border-box;
    flex: 1;

    @media (min-width: ${breakpoint.desktop}) {
        padding: 40px 60px;
    }
`;

export const LanguageWrapper = styled.div`
    position: absolute;
    top: 20px;
    right: 10px;
`;

export const ServiceTitle = styled(Title)`
    //display: flex;
    //align-items: center;
    //justify-content: center;
    text-align: center;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 40px;
    color: #fff;
    background-color: ${colors.brandPrimary};
    margin: 0;
    padding: 40px 100px;
    box-sizing: border-box;

    & > svg {
        vertical-align: middle;
    }

    path {
        fill: #fff;
    }
`;

export const CustomDatamatrixIcon = styled(Icon)`
    margin-right: 10px;
`;

export const PasswordTitle = styled(Title)`
    display: flex;
    margin-bottom: 15px;
    font-weight: 500;

    @media (min-width: ${breakpoint.desktop}) {
        margin-top: 40px;
        margin-bottom: 40px;
    }
`;

export const FormDescription = styled.p`
    text-align: center;
    font-weight: 400;
    font-size: 14px;

    @media (min-width: ${breakpoint.desktop}) {
        margin-bottom: 20px;
    }
`;

export const ButtonContainer = styled.div`
    display: grid;
    gap: 10px;
    margin: 20px auto;
    max-width: inherit;
`;

export const ControlOTPContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 20px auto;
    max-width: 500px;
    width: 100%;

    & > *:last-child {
        grid-column: 1 / -1;
    }
`;

export const Timer = styled.div`
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: ${colors.brandPrimary};
`;

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const ValidationList = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 20px;
`;

export const ValidationItem = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    transition: color 0.2s ease-in-out;
    min-height: 20px;
    color: ${colors.textPrimary};
`;

export const ValidationIconWrapper = styled.span<{isValid: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    margin-right: 8px;
    font-weight: bold;
    flex-shrink: 0;
    color: ${({isValid}) => (isValid ? colors.successDark : colors.textSecondary)};
`;

export const MessageWrapper = styled.div`
    max-width: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
`;

export const OptWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0;
`;
